module.exports = __webpack_public_path__ + "dd04a6973ff46652227d4691be00d98e.svg";